import { render } from "./DatenschutzPage.vue?vue&type=template&id=3f59ff66&scoped=true"
import script from "./DatenschutzPage.vue?vue&type=script&lang=js"
export * from "./DatenschutzPage.vue?vue&type=script&lang=js"

import "./DatenschutzPage.vue?vue&type=style&index=0&id=3f59ff66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f59ff66"]])

export default __exports__